<template>
	<page class="vehicle-list" title="Kunder">
		<new-table-view ref="table" :columns="[
			{
				label: 'Kunde',
				name: 'name'
			},
			{
				label: 'Adresse',
				name: 'address'
			},
			{
				label: 'Postnr.',
				name: 'zip'
			},
			{
				label: 'By',
				name: 'city'
			},
			{
				label: 'Telefon',
				name: 'phone'
			},
			{
				label: 'E-email',
				name: 'email'
			}
		]" :items="items" @itemClick="itemClick" :pagination="pagination">
			<template #footer>
				<pagination-bar-view style="padding: 10px 10px 10px 10px;" :pagination.sync="pagination" />
			</template>
		</new-table-view>
	</page>
</template>

<script>
	import NewTableView from '../views/NewTableView'

	import ContactModel from '../model/Contact'
	import ContactWindow from '../windows/ContactWindow'
	import CustomerWindow from '../customer/CustomerWindow'

	import { bus } from '../../bus'

    export default {
		watch: {
			pagination: function (n, o) {
				if (n.page == o.page && n.index == o.index) return;
				this.update();
			}
		},
		props: [],
		components: {
			newTableView: NewTableView
		},
		methods: {
			async update() {
				this.controller.abort();
				this.controller = new AbortController();

				this.items = null;

				const { data } = await this.axios.get(`/contacts/index/${this.pagination.index ? this.pagination.index.toLowerCase() : 'all'}/page/${this.pagination.page}/`, {
					signal: this.controller.signal
				});

				this.items		= data._items;
				this.pagination	= data._pagination;
			},
			async itemClick(item) {
				const self = this;
				const ent = await ContactModel.read(self.axios, item.id);

				self.$store.state.windowStack.push(CustomerWindow, {
					value: ent,
					submit: async function (entity) {
						if (await ContactModel.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							self.update();
						}
					}
				});
			}
		},
		data: function () {
			return {
				controller: new AbortController(),
				pagination: {
					page: 1,
					index: null,
					count: 0
				},
				items: [],
				columns: []
			};
		},
		mounted: function () {
			this.axios.put('/activity/contacts/');

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			this.update();
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.button {
		float: left;
		margin-left: 10px;
	}
</style>